import { StyleSheet } from 'aphrodite/no-important';

export default StyleSheet.create({
    wrapper: {
        display: 'table-cell',
        verticalAlign: 'middle'
    },
    container: {
        display: 'block',
        position: 'relative',
        height: '30px',
        lineHeight: '30px',
        width: '30px',
        fontSize: '14px'
    }
});



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/styles.js